(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complete-the-look"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CONFIG = {
      SLOT_VOCAB: {
        'jackets': 'outerwear', 'vests': 'outerwear', 'gilets': 'outerwear', 'coats': 'outerwear', 'overshirts': 'outerwear',
        't-shirts': 'top', 'tshirts': 'top', 'longsleeves': 'top', 'hoodies': 'top', 'sweaters': 'top', 'sweatshirts': 'top', 'polos': 'top', 'shirts': 'top', 'knitwear': 'top',
        'pants': 'bottom', 'shorts': 'bottom', 'swimshorts': 'bottom', 'swim shorts': 'bottom', 'swimwear': 'bottom', 'boardshorts': 'bottom', 'board shorts': 'bottom', 'jeans': 'bottom', 'trousers': 'bottom',
        'sweatpants': 'bottom', 'trackpants': 'bottom', 'track pants': 'bottom', 'joggers': 'bottom', 'cargos': 'bottom', 'cargo pants': 'bottom',
        'dresses': 'dress', 'dress': 'dress', 'jumpsuits': 'dress', 'jumpsuit': 'dress',
        'baby sets': 'dress', 'baby set': 'dress', 'sets': 'dress', 'set': 'dress', 'co-ords': 'dress', 'coords': 'dress',
        'sneakers': 'footwear', 'boots': 'footwear', 'footwear': 'footwear', 'shoes': 'footwear',
        'bags': 'accessory', 'sunglasses': 'accessory', 'caps': 'accessory', 'hats': 'accessory', 'beanies': 'accessory', 'belts': 'accessory'
      },

      STATEMENT_COLORS: ['red', 'orange', 'pink', 'yellow', 'purple', 'lime', 'fuchsia', 'magenta', 'cobalt', 'turquoise'],
      MAX_STATEMENT_COLORS: 1,

      BANNED_TYPE_PAIRS: [],

      BANNED_COLOR_PAIRS: [
        ['red', 'dark brown'],
        ['blue', 'green'],
        ['red', 'blue'],
        ['red', 'green']
      ],

      COLOR_FAMILIES: {
        brown:   ['brown', 'chocolate', 'coffee', 'mocha', 'espresso', 'tobacco', 'walnut'],
        blue:    ['blue', 'navy', 'cobalt', 'indigo', 'marine', 'denim', 'azure'],
        oatmeal: ['oatmeal', 'ecru'],
        red:     ['red', 'dark red', 'burgundy']
      },
      BANNED_FAMILY_PAIRS: [
        ['brown', 'blue'],
        ['brown', 'oatmeal'],
        ['brown', 'red']
      ],

      EXCLUDE_TYPES: [],
      EXCLUDE_COLORS: [],

      TRAITS: {
        sporty:   ['track', 'sportswear', 'tech', 'jersey', 'mesh', 'active', 'training', 'warmup', 'warm up', 'running'],
        tailored: ['suit', 'trouser', 'tailored', 'wool', 'pleated', 'blazer', 'oxford', 'poplin', 'chino', 'dress shirt', 'loafer'],
        hooded:   ['hoodie', 'hooded', 'zip-up', 'zip up', 'zipup']
      },
      SLOT_TRAITS: { shirts: 'tailored', trousers: 'tailored', hoodies: 'hooded' },

      BANNED_COMBOS: [
        [ { trait: 'sporty', role: 'bottom' },    { type: 'longsleeves' } ],
        [ { trait: 'sporty', role: 'outerwear' }, { type: 'hoodies' } ],
        [ { trait: 'sporty', role: 'outerwear' }, { type: 'longsleeves' } ],
        [ { type: 'shorts' }, { type: 'longsleeves' } ],
        [ { trait: 'sporty' }, { trait: 'tailored' } ],
        [ { type: 'swimshorts' }, { type: 'longsleeves' } ],
        [ { type: 'swimshorts' }, { type: 'hoodies' } ],
        [ { trait: 'tailored' }, { type: 'hoodies' } ],   // no dressy shirt / trousers etc. with hoodies
        [ { trait: 'tailored' }, { type: 'zip-ups' } ],   // no dressy shirt / trousers etc. with hoodies
        [ { trait: 'hooded' }, { trait: 'hooded' } ]
      ],

      REQUIRE_SAME_TRAIT: [
        { roles: ['top', 'bottom'], trait: 'sporty' }
      ],

      // Balance a slot so one over-stocked type doesn't dominate. FOUR's pool is
      // ~80% sweatpants; this makes the bottom slot land ~50/50 sweatpants vs other,
      // regardless of stock. `share` = target chance of the matched bucket when
      // both are available. Match by `types` (slot tags) and/or `trait`.
      BALANCE: [
        { role: 'bottom', types: ['sweatpants', 'trackpants', 'track pants', 'joggers'], share: 0.5 }
      ],

      GENDER_GROUPS: { boys: ['boys'], girls: ['girls'] },

      BRAND_GROUPS: {
        luxe:       ['bottega veneta', 'balenciaga', 'louboutin', 'jil sander', 'maison margiela', 'fear of god'],
        streetwear: ['amiri', 'casablanca', 'frei-mut', 'jacquemus', 'sacai', 'mihara yasuhiro', 'our legacy', 'seventh', 'on running','UGG'],
        trendy:     ['hellstar', 'nahmias', 'paly', 'satoshi nakamoto', 'rivington', 'willy chavarria', 'askyurself','Pal Sporting Goods'],
        custom1:    ['moncler', 'stone island', 'christian louboutin', 'new balance'],
        custom2:    ['prada', 'louboutin'],
        custom3:    ['essentials', 'adidas', 'salomon', 'new balance']
      },
      NEUTRAL_VENDORS: ['four', 'casio', 'bru eyewear', '2787', 'fugazzi', 'g-shock', 'librero', 'assouline', 'moscot', 'occu'],

      PREFER_TAG: 'fourbags',
      PREFER_WEIGHT: 3,
      CURATED_WEIGHT: 10,

      PALETTES: {
        black:  ['black', 'jet', 'onyx'],
        grey:   ['grey', 'gray', 'slate', 'silver', 'charcoal'],
        white:  ['white', 'off white', 'off-white', 'ivory', 'bone', 'cream', 'ecru'],
        tan:    ['tan', 'beige', 'sand', 'stone', 'oatmeal', 'khaki', 'camel', 'taupe', 'greige'],
        brown:  ['brown', 'chocolate', 'coffee', 'mocha', 'espresso', 'tobacco', 'walnut'],
        green:  ['green', 'olive', 'sage', 'forest', 'moss'],
        blue:   ['blue', 'navy', 'cobalt', 'indigo', 'marine', 'denim', 'azure', 'sky'],
        red:    ['red', 'burgundy', 'maroon', 'wine'],
        orange: ['orange', 'rust', 'terracotta'],
        pink:   ['pink', 'rose', 'fuchsia'],
        purple: ['purple', 'lilac', 'violet'],
        yellow: ['yellow', 'mustard', 'gold']
      },
      SCORING: { candidatesPerLook: 8, noise: 4 },

      REQUIRED: ['top', 'bottom', 'footwear'],
      OPTIONAL: { outerwear: 0.6, accessory: 0.5 },
      DRESS_REQUIRED: ['footwear'],
      DRESS_OPTIONAL: { outerwear: 0.5, accessory: 0.7 },
      MAX_ITEMS: 4,
      RENDER_ORDER: ['anchor', 'outerwear', 'dress', 'top', 'bottom', 'footwear', 'accessory']
    };

    // ========================= Engine =========================
    function norm(v){ return (v == null ? '' : String(v)).trim().toLowerCase(); }
    function pick(arr){ return arr[Math.floor(Math.random() * arr.length)]; }

    var activeSameVendor = false;

    function itemWeight(c){
      if (c.curated) return CONFIG.CURATED_WEIGHT;
      if (c.preferred) return CONFIG.PREFER_WEIGHT;
      return 1;
    }

    function weightedPick(cands){
      var total = 0, i;
      for (i = 0; i < cands.length; i++) total += itemWeight(cands[i]);
      var r = Math.random() * total;
      for (i = 0; i < cands.length; i++){
        r -= itemWeight(cands[i]);
        if (r <= 0) return cands[i];
      }
      return cands[cands.length - 1];
    }

    function matchesBalance(item, rule){
      if (rule.types && rule.types.indexOf(item.slotTag) !== -1) return true;
      if (rule.trait && item.traits && item.traits.indexOf(rule.trait) !== -1) return true;
      return false;
    }

    // Like weightedPick, but if a BALANCE rule exists for this slot, split the
    // candidates into matched vs other and pick the bucket by target share so an
    // over-stocked type can't dominate. Falls back to weightedPick otherwise.
    function balancedPick(role, cands){
      if (!cands.length) return weightedPick(cands);
      var rule = null;
      for (var i = 0; i < CONFIG.BALANCE.length; i++){
        if (CONFIG.BALANCE[i].role === role){ rule = CONFIG.BALANCE[i]; break; }
      }
      if (!rule) return weightedPick(cands);
      var A = [], B = [];
      for (var j = 0; j < cands.length; j++){ (matchesBalance(cands[j], rule) ? A : B).push(cands[j]); }
      if (A.length && B.length) return weightedPick(Math.random() < rule.share ? A : B);
      return weightedPick(cands);
    }

    function detectTraits(p){
      var hay = ((p.title || '') + ' ' + (p.type || '') + ' ' + (p.tags || []).join(' ')).toLowerCase();
      var out = [];
      Object.keys(CONFIG.TRAITS).forEach(function(trait){
        var kws = CONFIG.TRAITS[trait];
        for (var i = 0; i < kws.length; i++){ if (hay.indexOf(kws[i]) !== -1){ out.push(trait); break; } }
      });
      var st = CONFIG.SLOT_TRAITS && CONFIG.SLOT_TRAITS[p.slotTag];
      if (st && out.indexOf(st) === -1) out.push(st);
      return out;
    }

    function hasTrait(item, trait){ return item.traits && item.traits.indexOf(trait) !== -1; }

    function detectGender(p){
      var tags = (p.tags || []).map(norm);
      var found = [];
      Object.keys(CONFIG.GENDER_GROUPS).forEach(function(g){
        var kws = CONFIG.GENDER_GROUPS[g];
        for (var i = 0; i < kws.length; i++){ if (tags.indexOf(norm(kws[i])) !== -1){ found.push(g); break; } }
      });
      return found.length === 1 ? found[0] : null;
    }

    function groupsOf(vendor, tags){
      var v = norm(vendor);
      var tg = (tags || []).map(norm);
      var out = [];
      var G = CONFIG.BRAND_GROUPS;
      for (var g in G){
        var brands = G[g];
        for (var i = 0; i < brands.length; i++){
          var b = norm(brands[i]);
          if (v.indexOf(b) !== -1 || tg.indexOf(b) !== -1){ out.push(g); break; }
        }
      }
      if (out.length) return out;
      if (tg.indexOf(norm(CONFIG.PREFER_TAG)) !== -1) return null;
      for (var n = 0; n < CONFIG.NEUTRAL_VENDORS.length; n++){
        if (v === norm(CONFIG.NEUTRAL_VENDORS[n])) return null;
      }
      return v ? [v] : null;
    }

    function shareGroup(a, b){
      for (var i = 0; i < a.length; i++){ if (b.indexOf(a[i]) !== -1) return true; }
      return false;
    }

    function matchesDesc(item, m){
      if (m.role && item.role !== m.role) return false;
      if (m.type && item.slotTag !== m.type) return false;
      if (m.trait && !hasTrait(item, m.trait)) return false;
      if (m.group && !(item.groups && item.groups.indexOf(m.group) !== -1)) return false;
      return true;
    }

    function slotOf(token){
      var k = norm(token);
      if (!k) return null;
      if (CONFIG.SLOT_VOCAB[k]) return { role: CONFIG.SLOT_VOCAB[k], slotTag: k };
      if (CONFIG.SLOT_VOCAB[k + 's']) return { role: CONFIG.SLOT_VOCAB[k + 's'], slotTag: k + 's' };
      var sing = k.replace(/s$/, '');
      if (CONFIG.SLOT_VOCAB[sing]) return { role: CONFIG.SLOT_VOCAB[sing], slotTag: sing };
      return null;
    }

    function roleFor(p){
      var byType = slotOf(p.type);
      if (byType) return byType;
      var tags = p.tags || [];
      for (var i = 0; i < tags.length; i++){
        var r = slotOf(tags[i]);
        if (r) return r;
      }
      return null;
    }

    function bannedPair(list, a, b){
      if (!a || !b) return false;
      for (var i = 0; i < list.length; i++){
        var p0 = norm(list[i][0]), p1 = norm(list[i][1]);
        var hasA = a.indexOf(p0) !== -1, hasB = b.indexOf(p1) !== -1;
        var hasA2 = a.indexOf(p1) !== -1, hasB2 = b.indexOf(p0) !== -1;
        if ((hasA && hasB) || (hasA2 && hasB2)) return true;
      }
      return false;
    }

    function familiesOf(color){
      var out = [];
      if (!color) return out;
      Object.keys(CONFIG.COLOR_FAMILIES).forEach(function(fam){
        var kws = CONFIG.COLOR_FAMILIES[fam];
        for (var i = 0; i < kws.length; i++){ if (color.indexOf(kws[i]) !== -1){ out.push(fam); break; } }
      });
      return out;
    }

    function bannedFamilyPair(a, b){
      if (!a || !b) return false;
      var fa = familiesOf(a), fb = familiesOf(b);
      for (var i = 0; i < CONFIG.BANNED_FAMILY_PAIRS.length; i++){
        var x = CONFIG.BANNED_FAMILY_PAIRS[i][0], y = CONFIG.BANNED_FAMILY_PAIRS[i][1];
        if ((fa.indexOf(x) !== -1 && fb.indexOf(y) !== -1) || (fa.indexOf(y) !== -1 && fb.indexOf(x) !== -1)) return true;
      }
      return false;
    }

    function statementSet(items){
      var stmt = {};
      for (var i = 0; i < items.length; i++){
        var col = items[i].color;
        if (!col) continue;
        for (var k = 0; k < CONFIG.STATEMENT_COLORS.length; k++){
          var s = CONFIG.STATEMENT_COLORS[k];
          if (col.indexOf(s) !== -1) stmt[s] = true;
        }
      }
      return stmt;
    }

    function isStatementColor(color){
      if (!color) return false;
      for (var i = 0; i < CONFIG.STATEMENT_COLORS.length; i++){
        if (color.indexOf(CONFIG.STATEMENT_COLORS[i]) !== -1) return true;
      }
      return false;
    }

    function paletteOf(color){
      var out = [];
      if (!color) return out;
      var P = CONFIG.PALETTES;
      for (var fam in P){
        var kws = P[fam];
        for (var i = 0; i < kws.length; i++){ if (color.indexOf(kws[i]) !== -1){ out.push(fam); break; } }
      }
      return out;
    }

    function scoreLook(items){
      var i, c, score = 0;
      var nStatement = Object.keys(statementSet(items)).length;
      if (nStatement === 0) score += 30;
      else if (nStatement === 1) score += 20;
      else score -= 15 * (nStatement - 1);

      var famCount = {}, maxFam = 0;
      for (i = 0; i < items.length; i++){
        var fams = paletteOf(items[i].color);
        for (var f = 0; f < fams.length; f++){ famCount[fams[f]] = (famCount[fams[f]] || 0) + 1; }
      }
      for (var k in famCount){ if (famCount[k] > maxFam) maxFam = famCount[k]; }
      if (maxFam >= 3) score += 18; else if (maxFam === 2) score += 7;

      var neutrals = 0;
      for (i = 0; i < items.length; i++){ c = items[i].color; if (c && !isStatementColor(c)) neutrals++; }
      score += neutrals * 4;

      var vend = {}, maxVend = 0;
      for (i = 0; i < items.length; i++){ var v = items[i].vendor; if (v){ vend[v] = (vend[v] || 0) + 1; } }
      for (var vk in vend){ if (vend[vk] > maxVend) maxVend = vend[vk]; }
      score += maxVend * 3;

      for (i = 0; i < items.length; i++){
        if (items[i].role === 'footwear'){ if (!isStatementColor(items[i].color)) score += 8; break; }
      }
      return score;
    }

    function isExcludedColor(color){
      if (!color) return false;
      for (var i = 0; i < CONFIG.EXCLUDE_COLORS.length; i++){
        if (color.indexOf(norm(CONFIG.EXCLUDE_COLORS[i])) !== -1) return true;
      }
      return false;
    }

    function compatible(chosen, cand){
      for (var h = 0; h < chosen.length; h++){
        if (bannedPair(CONFIG.BANNED_COLOR_PAIRS, chosen[h].color, cand.color)) return false;
        if (bannedFamilyPair(chosen[h].color, cand.color)) return false;
      }
      if (cand.gender){
        for (var gi = 0; gi < chosen.length; gi++){
          if (chosen[gi].gender && chosen[gi].gender !== cand.gender) return false;
        }
      }
      if (activeSameVendor && cand.vendor){
        for (var vi = 0; vi < chosen.length; vi++){
          if (chosen[vi].vendor && chosen[vi].vendor !== cand.vendor) return false;
        }
      }
      if (cand.groups){
        for (var bgi = 0; bgi < chosen.length; bgi++){
          var og = chosen[bgi].groups;
          if (og && !shareGroup(og, cand.groups)) return false;
        }
      }
      if (cand.curated) return true;

      for (var i = 0; i < chosen.length; i++){
        var c = chosen[i];
        if (bannedPair(CONFIG.BANNED_TYPE_PAIRS, c.slotTag, cand.slotTag)) return false;
      }
      var stmt = statementSet(chosen.concat([cand]));
      if (Object.keys(stmt).length > CONFIG.MAX_STATEMENT_COLORS) return false;

      for (var b = 0; b < CONFIG.BANNED_COMBOS.length; b++){
        var A = CONFIG.BANNED_COMBOS[b][0], B = CONFIG.BANNED_COMBOS[b][1];
        var candA = matchesDesc(cand, A), candB = matchesDesc(cand, B);
        if (candA || candB){
          for (var j = 0; j < chosen.length; j++){
            if (candA && matchesDesc(chosen[j], B)) return false;
            if (candB && matchesDesc(chosen[j], A)) return false;
          }
        }
      }

      for (var s = 0; s < CONFIG.REQUIRE_SAME_TRAIT.length; s++){
        var rule = CONFIG.REQUIRE_SAME_TRAIT[s];
        if (rule.roles.indexOf(cand.role) === -1) continue;
        var candHas = hasTrait(cand, rule.trait);
        for (var k2 = 0; k2 < chosen.length; k2++){
          var o = chosen[k2];
          if (o.role !== cand.role && rule.roles.indexOf(o.role) !== -1){
            if (hasTrait(o, rule.trait) !== candHas) return false;
          }
        }
      }
      return true;
    }

    function buildLook(byRole, anchor, curatedFirst){
      var chosen = anchor ? [anchor] : [];
      var anchorRole = anchor ? anchor.role : null;
      var maxItems = CONFIG.MAX_ITEMS || 99;
      var isDress = (anchorRole === 'dress');

      function candsFor(role){
        var all = (byRole[role] || []).filter(function(p){ return compatible(chosen, p); });
        if (curatedFirst){
          var cur = all.filter(function(p){ return p.curated; });
          if (cur.length) return cur;
        }
        return all;
      }
      function hasCurated(role){
        return curatedFirst && (byRole[role] || []).some(function(p){ return p.curated; });
      }

      var required = (isDress ? CONFIG.DRESS_REQUIRED : CONFIG.REQUIRED).filter(function(r){ return r !== anchorRole; });
      for (var i = 0; i < required.length; i++){
        var cands = candsFor(required[i]);
        if (!cands.length) return null;
        chosen.push(balancedPick(required[i], cands));
      }

      var optMap = isDress ? CONFIG.DRESS_OPTIONAL : CONFIG.OPTIONAL;
      var optionals = Object.keys(optMap).filter(function(role){
        if (role === anchorRole || !(byRole[role] || []).length) return false;
        var chance = hasCurated(role) ? 1 : optMap[role];
        return Math.random() < chance;
      });
      for (var o = 0; o < optionals.length && chosen.length < maxItems; o++){
        var ocands = candsFor(optionals[o]);
        if (ocands.length) chosen.push(balancedPick(optionals[o], ocands));
      }

      if (chosen.length === 3 && chosen.length < maxItems){
        var bags = (byRole.accessory || []).filter(function(p){
          return p.slotTag === 'bags' && chosen.indexOf(p) === -1 && compatible(chosen, p);
        });
        if (bags.length) chosen.push(weightedPick(bags));
      }

      return chosen.length >= (isDress ? 2 : 3) ? chosen : null;
    }

    function prep(p){
      var r = roleFor(p);
      if (!r) return null;
      p.role = r.role; p.slotTag = r.slotTag; p.color = norm(p.color);
      p.traits = detectTraits(p);
      p.gender = detectGender(p);
      p.vendor = norm(p.vendor);
      p.groups = groupsOf(p.vendor, p.tags);
      p.preferred = (p.tags || []).some(function(t){ return norm(t) === CONFIG.PREFER_TAG; });
      return p;
    }

    function assemble(products, n, anchor, matches, curatedFirst, sameVendor){
      activeSameVendor = !!sameVendor;
      if (anchor){
        if (!anchor.img){
          anchor = null;
        } else {
          var ar = roleFor(anchor);
          anchor.role = ar ? ar.role : 'anchor';
          anchor.slotTag = ar ? ar.slotTag : null;
          anchor.color = norm(anchor.color);
          anchor.traits = detectTraits(anchor);
          anchor.gender = detectGender(anchor);
          anchor.vendor = norm(anchor.vendor);
          anchor.groups = groupsOf(anchor.vendor, anchor.tags);
        }
      }

      var byRole = {};
      products.forEach(function(p){
        if (!p.img) return;
        if (anchor && p.url === anchor.url) return;
        if (!prep(p)) return;
        if (CONFIG.EXCLUDE_TYPES.indexOf(p.slotTag) !== -1) return;
        if (isExcludedColor(p.color)) return;
        (byRole[p.role] = byRole[p.role] || []).push(p);
      });

      if (matches && matches.length){
        matches.forEach(function(m){
          if (!m.img) return;
          if (anchor && m.url === anchor.url) return;
          if (!prep(m)) return;
          m.curated = true;
          var arr = (byRole[m.role] = byRole[m.role] || []);
          var existing = null;
          for (var x = 0; x < arr.length; x++){ if (arr[x].url === m.url){ existing = arr[x]; break; } }
          if (existing) existing.curated = true;
          else arr.push(m);
        });
      }

      var candidates = [], seen = {}, attempts = 0;
      var want = n * (CONFIG.SCORING.candidatesPerLook || 6);
      var cap = want * 12;
      while (candidates.length < want && attempts < cap){
        attempts++;
        var look = buildLook(byRole, anchor, curatedFirst);
        if (!look) continue;
        var key = look.map(function(p){ return p.url; }).sort().join('|');
        if (seen[key]) continue;
        seen[key] = true;
        candidates.push({ look: look, score: scoreLook(look) + Math.random() * (CONFIG.SCORING.noise || 0) });
      }
      candidates.sort(function(a, b){ return b.score - a.score; });
      var looks = candidates.slice(0, n).map(function(c){ return c.look; });

      if (!looks.length){
        var counts = {};
        Object.keys(byRole).forEach(function(r){ counts[r] = byRole[r].length; });
        console.warn('[complete-the-look] built 0 looks. Candidates per role:', counts);
      }
      return looks;
    }

    // ========================= Render =========================
    var EYE = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="2.5"/></svg>';
    var CLOSE = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6L6 18"/></svg>';

    function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]; }); }

    function orderItems(look){
      return look.slice().sort(function(a, b){
        return CONFIG.RENDER_ORDER.indexOf(a.role) - CONFIG.RENDER_ORDER.indexOf(b.role);
      });
    }

    function cardHTML(look){
      var items = orderItems(look);
      var grid = items.map(function(p){
        return '<a class="ctl-item role-' + p.role + '" href="' + esc(p.url) + '">' +
               '<img loading="lazy" src="' + esc(p.img) + '"' +
               (p.fallback ? ' data-fallback="' + esc(p.fallback) + '"' : '') +
               ' alt="' + esc(p.title) + '"></a>';
      }).join('');
      var list = items.map(function(p){
        return '<li><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></li>';
      }).join('');
      return '<article class="ctl-card">' +
               '<div class="ctl-card__label"></div>' +
               '<div class="ctl-grid">' + grid + '</div>' +
               '<button class="ctl-eye" aria-label="Shop this look">' + EYE + '</button>' +
               '<div class="ctl-panel" hidden>' +
                 '<p class="ctl-panel__title">In this look</p>' +
                 '<ul>' + list + '</ul>' +
                 '<button class="ctl-panel__close" aria-label="Close">' + CLOSE + '</button>' +
               '</div>' +
             '</article>';
    }

    function wireCard(card){
      var eye = card.querySelector('.ctl-eye');
      var panel = card.querySelector('.ctl-panel');
      var close = card.querySelector('.ctl-panel__close');
      if (eye && panel) eye.addEventListener('click', function(){ panel.hidden = false; });
      if (close && panel) close.addEventListener('click', function(){ panel.hidden = true; });
    }

    function wireImages(scope){
      scope.querySelectorAll('.ctl-item img').forEach(function(img){
        function fail(){
          var fb = img.getAttribute('data-fallback');
          if (fb && img.getAttribute('src') !== fb && !img.dataset.fellBack){
            img.dataset.fellBack = '1';
            img.setAttribute('src', fb);
          } else {
            var cell = img.closest('.ctl-item');
            if (cell) cell.style.visibility = 'hidden';
          }
        }
        img.addEventListener('error', fail);
        if (img.complete && img.naturalWidth === 0) fail();
      });
    }

    function wireCarousel(root){
      var track = root.querySelector('[data-ctl-track]');
      var prev = root.querySelector('[data-ctl-prev]');
      var next = root.querySelector('[data-ctl-next]');
      function step(){
        var card = track.querySelector('.ctl-card');
        return card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
      }
      function update(){
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function(){ track.scrollBy({ left: -step() }); });
      if (next) next.addEventListener('click', function(){ track.scrollBy({ left: step() }); });
      track.addEventListener('scroll', update, { passive: true });
      update();
      return update;
    }

    function computeDiag(products){
      var byRole = {}, noImg = 0, noSlot = 0;
      products.forEach(function(p){
        if (!p.img){ noImg++; return; }
        var r = roleFor(p);
        if (!r){ noSlot++; return; }
        (byRole[r.role] = byRole[r.role] || []).push(p);
      });
      var counts = {};
      Object.keys(byRole).forEach(function(k){ counts[k] = byRole[k].length; });
      return { total: products.length, counts: counts, noImg: noImg, noSlot: noSlot, sample: products[0] };
    }

    function renderDebug(root, d, built, anchor){
      var box = document.createElement('pre');
      box.className = 'ctl__debug';
      box.style.cssText = 'font:12px/1.5 monospace;padding:10px;margin-bottom:12px;border:1px dashed var(--ctl-accent);white-space:pre-wrap;overflow:auto;';
      var s = d.sample || {};
      var anchorLine = anchor
        ? 'anchor (this product): "' + anchor.title + '" role=' + (anchor.role || 'UNRECOGNISED — looks fall back to random')
        : 'anchor: none (not a product page)';
      box.textContent =
        'JS ran. pool items parsed: ' + d.total + '\n' +
        anchorLine + '\n' +
        'candidates per role: ' + JSON.stringify(d.counts) + '\n' +
        'skipped (no image): ' + d.noImg + '   skipped (slot not recognised): ' + d.noSlot + '\n' +
        'looks built: ' + built + '\n' +
        'sample product: ' + JSON.stringify({ title: s.title, type: s.type, color: s.color, tags: s.tags, hasImg: !!s.img });
      var vp = root.querySelector('.ctl__viewport');
      root.insertBefore(box, vp);
    }

    function init(root){
      if (root.dataset.ctlReady) return;
      root.dataset.ctlReady = '1';
      var debug = root.dataset.ctlDebug === 'true';
      var poolEl = root.querySelector('[data-ctl-pool]');
      var track = root.querySelector('[data-ctl-track]');
      if (!poolEl || !track) return;

      var products;
      try { products = JSON.parse(poolEl.textContent); }
      catch (e) {
        console.warn('[complete-the-look] bad pool JSON', e);
        if (debug){
          var err = document.createElement('pre');
          err.style.cssText = 'font:12px/1.5 monospace;padding:10px;border:1px dashed red;white-space:pre-wrap;';
          err.textContent = 'JS ran but the pool JSON failed to parse. Error: ' + e.message;
          root.insertBefore(err, root.querySelector('.ctl__viewport'));
        }
        return;
      }

      var anchorEl = root.querySelector('[data-ctl-anchor]');
      var anchor = null;
      if (anchorEl){ try { anchor = JSON.parse(anchorEl.textContent); } catch (e) { anchor = null; } }

      var matchesEl = root.querySelector('[data-ctl-matches]');
      var matches = null;
      if (matchesEl){ try { matches = JSON.parse(matchesEl.textContent); } catch (e) { matches = null; } }

      var curatedFirst = root.dataset.ctlCuratedFirst === 'true';
      var sameVendor = root.dataset.ctlSameVendor === 'true';
      var n = parseInt(root.dataset.ctlCount, 10) || 8;
      var debugDone = false, carouselUpdate = null;

      function build(){
        var looks = products.length ? assemble(products, n, anchor, matches, curatedFirst, sameVendor) : [];
        if (debug && !debugDone){ renderDebug(root, computeDiag(products), looks.length, anchor); debugDone = true; }
        if (!looks.length){ if (!debug) root.hidden = true; return; }
        root.hidden = false;
        track.innerHTML = looks.map(cardHTML).join('');
        track.querySelectorAll('.ctl-card').forEach(wireCard);
        wireImages(track);
        if (!carouselUpdate) carouselUpdate = wireCarousel(root);
        else { track.scrollLeft = 0; carouselUpdate(); }
      }

      build();

      var regenBtn = root.querySelector('[data-ctl-regen]');
      if (regenBtn) regenBtn.addEventListener('click', build);
    }

    function boot(scope){ (scope || document).querySelectorAll('[data-ctl-root]').forEach(init); }

    if (document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', function(){ boot(); });
    } else { boot(); }

    document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
